import React from "react";
import SportsList from "../../components/sportsList";
import SportsBookWrapper from "../sportsBookWrapper";
import FavoritesGamesList from "../../components/favoritesGamesList/index";
import BoostedOdds from "../../components/boostedOdds";
import DayFilter from "../../components/dayFilter";
import Config from "../../../config/main";
import PredefinedMultiples from "../../components/predefinedMultiples";

export default function prematchTemplate() {
    let isAsian = this.props.isAsian,
        timeFilter = this.state.timeFilter,
        { sportAlias, regionId, competitionId } = this.props.routeParams,
        gameType = "prematch",
        loadSportsBook = sportAlias && sportAlias !== "Favorites";
    return (<div className={`import-view-container ${!isAsian ? "sport-view-wrapper" : "asian-view"}`} onClick={this.handleClick()}>
        <SportsList
            sportAlias={sportAlias}
            location={this.props.location}
            gameType={gameType}
            regionId={regionId}
            competitionId={competitionId}
            // key={timeFilter}
            timeFilter={timeFilter}
            isAsian={isAsian}
        />
        {
            sportAlias && sportAlias === "multiples" &&
            <PredefinedMultiples />
        }
        {
            Config.main.hasDayFilter &&
                <DayFilter
                    key={timeFilter}
                    timeFilter={timeFilter}
                    setTimeFilter={this.setTimeFilter}
                />
        }
        {
            sportAlias && sportAlias === "boosted" &&
            <BoostedOdds sportAlias={sportAlias}
                timeFilter={timeFilter}
                isAsian={isAsian}
                gameType={gameType}
                regionId={regionId}
                competitionId={competitionId}
                setTimeFilter={this.setTimeFilter}
                child={this.props.children} />
        }
        {
            sportAlias !== "boosted" && loadSportsBook && sportAlias !== "multiples" && <SportsBookWrapper sportAlias={sportAlias}
                timeFilter={timeFilter}
                isAsian={isAsian}
                gameType={gameType}
                regionId={regionId}
                competitionId={competitionId}
                setTimeFilter={this.setTimeFilter}
                child={this.props.children} />
        }
        {
            sportAlias && sportAlias === "Favorites" && <FavoritesGamesList />
        }
    </div>);
};